import { PLATFORMS_DATA, PLATFORMS_LOADED, PLATFORMS_ERROR } from "../reducers/platformsReducer";

export const getPlatformsData = (url) => (dispatch) => {
	fetch(url)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: PLATFORMS_DATA, payload: data._data.platforms });
				dispatch({ type: PLATFORMS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: PLATFORMS_ERROR, payload: err.message });
		});
}